export const ENTITY_METADATA = Symbol('__ENTITY_METADATA__');

export const ENTITY_EXCLUDE_IN_REQUEST = Symbol('__ENTITY_EXCLUDE_IN_REQUEST__');
